import { Component, OnInit, Input } from '@angular/core';
import { NUMBERS, SCREEN_NAME } from 'src/app/constants/app.constants';

@Component({
  selector: 'app-user-story-product-card',
  templateUrl: './user-story-product-card.component.html',
  styleUrls: ['./user-story-product-card.component.scss']
})
export class UserStoryProductCardComponent implements OnInit {



  /**
   * product data
   */
  @Input() productData: any;
  /**
   * product type
   */
  @Input() productType: any;

  public numbers = NUMBERS;

  public screenName = SCREEN_NAME;

  constructor() { }

  ngOnInit(): void {
  }

}
